import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { getValueInRange } from '@ng-bootstrap/ng-bootstrap/util/util';
import { Observable } from 'rxjs';
import { AgenciasService } from 'src/app/_services/agencias.service';
import { AuxiliarService } from 'src/app/_services/auxiliar.service';



@Component({
  selector: 'app-agencia-detalle',
  templateUrl: './agencia-detalle.component.html',
  styleUrls: ['./agencia-detalle.component.css']
})
export class AgenciaDetalleComponent implements OnInit {
  id: string;
  agencia: {
    nombre: string,
    vendedor: string,
    direccion: string,
    telefono: string,
    email: string,
    razonSocial: string,
    facebook: string,
    instagram: string,
    twitter: string,
  };
  existImg = false;
  imagen: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private agenciasService:AgenciasService,
    private auxService:AuxiliarService,
    public domSrv: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.params.id;
    this.get();      
  }

  get(){
    this.agenciasService.getAgencia(this.id).subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        if(data.body.imagen!==null && data.body.imagen!==undefined && data.body.imagen!==''){
          this.existImg = true;
          this.imagen = data.body.imagen;
        }
        var response = data.body.agencia;        
        this.agencia = {
          nombre: this.getValue(response.nombre_agencia),
          vendedor: this.getValue(response.nombre_vendedor),
          direccion: this.getValue(response.direccion_vendedor),
          telefono: this.getValue(response.telefono_agencia),
          email: this.getValue(response.email_agencia),
          razonSocial: this.getValue(response.razon_social),
          facebook: this.getValue(response.facebook_agencia),
          instagram: this.getValue(response.instagram_agencia),
          twitter:this.getValue(response.twitter_agencia),
        }       
      }
    });      
  }

  getValue(cadena: string){
    return (cadena === null || cadena === undefined || cadena === '')?'-':cadena;
  }

}
